import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { ButtonModule } from "primeng/button";

export type Kno2ButtonSeverity = "primary" | "secondary" | "success" | "info" | "warn" | "danger";
export type Kno2ButtonSize = "small" | "large";
export type Kno2ButtonType = "button" | "submit" | "reset";

@Component({
    selector: "kno2-button",
    imports: [ButtonModule],
    template: `
        <button
            pButton
            [type]="type()"
            [severity]="severity()"
            [size]="size()"
            [outlined]="outlined()"
            [text]="text()"
            [rounded]="rounded()"
            [fluid]="fullWidth()"
            [loading]="loading() ?? false"
            [disabled]="disabled()">
            <ng-content></ng-content>
        </button>
    `,
    host: { "[class.fullwidth]": "fullWidth()" },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
    public readonly type = input<Kno2ButtonType>("button");
    public readonly severity = input<Kno2ButtonSeverity>("primary");
    public readonly size = input<Kno2ButtonSize>();
    public readonly outlined = input<boolean>(false);
    public readonly text = input<boolean>(false);
    public readonly rounded = input<boolean>(false);
    public readonly fullWidth = input<boolean>(false);
    public readonly loading = input<boolean | null>(false);
    public readonly disabled = input<boolean>(false);
}
